import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import {
  FaCalendarAlt,
  FaPhone,
  FaUser,
  FaRupeeSign,
  FaMapMarkerAlt,
  FaShoppingCart,
  FaDownload,
  FaPrint,
} from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../baseurl";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../../assets/img/logo.webp";

function InvoiceView() {
  const { id } = useParams();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const invoiceRef = useRef();

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const res = await axios.get(`${baseurl}invoices/${id}`);
        if (res.data.success) {
          setInvoice(res.data.data);
        } else {
          Swal.fire("Error", "Invoice not found", "error");
        }
      } catch (err) {
        console.error("Error fetching invoice:", err);
        Swal.fire("Error", "Failed to load invoice details.", "error");
      } finally {
        setLoading(false);
      }
    };
    fetchInvoice();
  }, [id]);

  // ✅ PDF Export
  const handleDownloadPDF = async () => {
    const input = invoiceRef.current;
    const pdf = new jsPDF("p", "mm", "a4");
    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      logging: false,
    });
    const imgData = canvas.toDataURL("image/png");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`Invoice_${invoice.id}.pdf`);
  };



  // ✅ Calculate totals from invoice items
// ✅ Calculate totals from invoice items safely
const totalInvoiceAmount = invoice?.items?.reduce(
  (sum, item) => sum + parseFloat(item.qty || 0) * parseFloat(item.amt || 0),
  0
) || 0;

const totalDiscountAmount = invoice?.items?.reduce(
  (sum, item) => sum + parseFloat(item.discount || 0),
  0
) || 0;


  // ✅ Print Invoice
  const handlePrint = () => {
    const printContents = invoiceRef.current.innerHTML;
    const printWindow = window.open("", "_blank", "width=800,height=900");
    printWindow.document.write(`
      <html>
        <head>
          <title>Invoice #Inv-BP-000${invoice.id}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
              padding: 0;
              background: #fff;
              color: #000;
            }
            table {
              width: 100%;
              border-collapse: collapse;
            }
            table, th, td {
              border: 1px solid #ccc;
            }
            th, td {
              padding: 8px;
              text-align: left;
            }
            h4, h5 {
              margin: 0;
              padding: 0;
            }
            .text-end { text-align: right; }
            .text-center { text-align: center; }
            .fw-bold { font-weight: bold; }
            .text-success { color: green; }
            .text-danger { color: red; }
            .text-primary { color: #007bff; }

            /* ✅ Keep Customer + Invoice Info side-by-side when printing */
        @media print {
          .row {
            display: flex !important;
            flex-wrap: nowrap !important;
          }
          .col-6 {
            width: 50% !important;
            display: inline-block !important;
            vertical-align: top !important;
          }
        }

        
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContents}
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  if (loading) {
    return (
      <div className="d-flex vh-100 justify-content-center align-items-center">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  if (!invoice) {
    return (
      <div className="d-flex vh-100 justify-content-center align-items-center">
        <h5 className="text-muted">Invoice not found.</h5>
      </div>
    );
  }

  // ✅ Calculate refund-adjusted total
  const totalRefund = invoice.returns?.reduce(
    (sum, ret) => sum + parseFloat(ret.total_refund || 0),
    0
  );
  const finalTotal = parseFloat(invoice.net_amount) - totalRefund;

  return (
    <>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper bg-light">
        <div className="container py-4">
          <div className="card border-0 shadow-lg rounded-4">
            <div className="card-header d-flex justify-content-between align-items-center text-white rounded-top-4">
              <h4 className="mb-0 fw-bold d-flex align-items-center gap-2">
                <FaShoppingCart /> Invoice Details
              </h4>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-light btn-sm fw-semibold rounded-pill shadow-sm"
                  onClick={handleDownloadPDF}
                >
                  <FaDownload className="me-2" />
                  Download PDF
                </button>
                <button
                  className="btn btn-secondary btn-sm fw-semibold rounded-pill shadow-sm"
                  onClick={handlePrint}
                >
                  <FaPrint className="me-2" />
                  Print
                </button>
              </div>
            </div>

            <div className="card-body p-4" ref={invoiceRef}>
              {/* Customer + Invoice Info */}
              <div className="row mb-4">
                <div className="text-center">
                  <h6 className="text-dark text-center">
                    Address - Bajaj pharmacy 3rd floor, Crown Tower opposite
                    Fruit mandi, Niranjanpur, Dehradun
                    <br />
                    Contact no. - 8755153920
                  </h6>
                </div>
               
              </div>
 <hr /> 
              <div className="row">
                  <div className="col-6">
                    <img
                      src={logo}
                      className="img-fluid"
                      style={{ maxHeight: "80px" }}
                    />
                  </div>
                  <div className="col-6">
                    <div className="text-end">
                      <h5>GST NO.: 05ACZPB9757G1Z1</h5>
                      <h5>Licence NO.: UA-DEH-139087</h5>
                    </div>
                  </div>
                </div>
 <hr />

<div className="row">
   <div className=" col-6">
                  <h5 className="fw-bold text-dark mb-3">
                    Customer Information
                  </h5>
                  <p className="mb-1">
                    <FaUser className="me-2 text-secondary" />
                    <strong>{invoice.full_name}</strong>
                  </p>
                  <p className="mb-1">
                    <FaPhone className="me-2 text-secondary" />
                    {invoice.phone}
                  </p>
                  <p className="mb-1">
                    <FaMapMarkerAlt className="me-2 text-secondary" />
                    {invoice.address}
                  </p>
                </div>

                <div className="col-6 text-md-end">
                  <h5 className="fw-bold text-dark mb-3">Invoice Info</h5>
                  <p className="mb-1">
                    <FaCalendarAlt className="me-2 text-secondary" />
                    Date:{" "}
                    <strong>
                      {new Date(invoice.date).toLocaleDateString("en-GB")}
                    </strong>
                  </p>
                  <p className="mb-1">
                    <FaRupeeSign className="me-2 text-secondary" />
                    Payment Mode:{" "}
                    <strong className="text-capitalize">
                      {invoice.payment_mode}
                    </strong>
                  </p>

                  <p className="mb-1">
                    <FaRupeeSign className="me-2 text-secondary" />
                    Invoice No.:{" "}
                    <strong className="text-capitalize">
                     #{invoice.id}
                    </strong>
                  </p>
                </div>
</div>


              {/* Items Table */}
              <div className="table-responsive mb-4">
                <h5 className="fw-bold text-dark mb-3">Invoice Items</h5>
                {(() => {
                  const hasReturned = invoice.items?.some(
                    (item) => item.is_returned === 1
                  );

                  return (
                    <table className="table table-bordered align-middle">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Medicine Name</th>
                          <th>Qty</th>
                          <th>Amount</th>
                          <th>Discount </th>
                          <th>Total</th>
                          {hasReturned && <th>Returned</th>}
                          {hasReturned && <th>Return Qty</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {invoice.items?.map((item, idx) => (
                          <tr key={item.id}>
                            <td>{idx + 1}</td>
                            <td>
  {item.medicine_name.replace(/\s*\[.*\]$/, "")}
</td>
                            <td>{item.qty}</td>
                            <td>₹{item.amt}</td>
                            <td>
  {item.discount}   {/* show correct percentage */}
</td>
                            <td className="fw-semibold text-success">
  ₹{
    (
      item.amt * item.qty -
      (item.amt * item.qty * item.discount) / 100
    ).toFixed(2)
  }
</td>
                            {hasReturned && (
                              <>
                                <td>
                                  {item.is_returned === 1 ? (
                                    <span className="badge bg-danger">Yes</span>
                                  ) : (
                                    <span className="badge bg-success">No</span>
                                  )}
                                </td>
                                <td>{item.return_qty || 0}</td>
                              </>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  );
                })()}
              </div>

              {/* Return Section */}
              {invoice.returns && invoice.returns.length > 0 && (
                <div className="mt-4">
                  <h5 className="fw-bold text-dark mb-3">Return Details</h5>
                  <table className="table table-bordered align-middle">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Customer Name</th>
                        <th>Phone</th>
                        <th>Return Date</th>
                        <th>Total Refund</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoice.returns.map((ret, i) => (
                        <tr key={ret.id}>
                          <td>{i + 1}</td>
                          <td>{ret.customer_name}</td>
                          <td>{ret.phone}</td>
                          <td>{ret.return_date}</td>
                          <td className="fw-semibold text-danger">
                            ₹{ret.total_refund}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Summary Footer */}
              <div className="mt-4 border-top pt-3">
                <div className="table-responsive">
                  <table className="table table-bordered table-sm w-50 ms-auto text-end">
                    <tbody>
                      <tr>
                        <th className="bg-light text-start">
                          Total Invoice Amount
                        </th>
                        <td className="fw-bold text-dark">
                         ₹{totalInvoiceAmount.toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <th className="bg-light text-start">Discount</th>
                       <td className="fw-bold text-dark">
  ₹{(Number(totalInvoiceAmount) - Number(finalTotal)).toFixed(2)}
</td>
                      </tr>
                      {totalRefund > 0 && (
                        <tr>
                          <th className="bg-light text-start text-danger">
                            Total Refunds
                          </th>
                          <td className="fw-bold text-danger">
                            ₹{totalRefund}
                          </td>
                        </tr>
                      )}
                      <tr className="table-primary">
                        <th className="text-start fs-6">
                          Final Payable Amount
                        </th>
                        <td className="fw-bold fs-5 text-primary">
                           ₹{Math.round(finalTotal).toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>



<div className="text-end mt-5">
  <p className="text-dark mt-3">Authorised Signature</p>
</div>

<div className="text-center mt-5">
  <p className="text-dark mt-3" style={{textDecoration: "underline"}}><strong>Medicine Once Sold Cannot Be Returned.</strong></p>
</div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default InvoiceView;
